module.exports = __webpack_public_path__ + "static/img/share-qq.172514b.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/share-qq.png
// module id = lClj
// module chunks = 0